import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface PaintBoothEntry {
  id: string;
  number: number;
  plate: string;
  vehicleName: string;
  mechanicName: string | null;
  status: string;
  /** Entrada na etapa atual, ISO. */
  since: string;
}

export interface PaintBoothData {
  /** A oficina tem o módulo de funilaria. Sem ele o card não aparece. */
  enabled: boolean;
  booths: { id: string; label: string }[];
  inBooth: PaintBoothEntry[];
  upNext: PaintBoothEntry[];
}

export const PAINT_BOOTH_QUERY_KEY = ['paint-booth'] as const;

/**
 * A cabine de pintura (F3.5): quem está nela e os próximos. Atualiza pelo
 * WebSocket do dashboard (`useDashboard` invalida esta chave quando uma OS
 * muda de etapa ou de status) e, na falta dele, a cada minuto.
 */
export function usePaintBooth(workshopId: string | null) {
  return useQuery<PaintBoothData>({
    queryKey: PAINT_BOOTH_QUERY_KEY,
    queryFn: async () => (await api.get('/workshops/my/paint-booth')).data,
    enabled: !!workshopId,
    // Só quem tem funilaria rebusca sozinho: para a maioria da base a resposta
    // é `enabled: false` e não muda de um minuto para o outro.
    refetchInterval: (query) => (query.state.data?.enabled ? 60_000 : false),
  });
}
